import { Component } from '@angular/core';
import { Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, inject, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CompanyApi } from '@app/services/company-api';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TypeOptions } from '@app/interface/type-options';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-confirm-email-send-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  templateUrl: './confirm-email-send-dialog.component.html',
  styleUrl: './confirm-email-send-dialog.component.scss',
})
export class ConfirmEmailSendDialogComponent {
  confirmed = false;
  email_address = '';
  company_id = 0;
  organization_id = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialogRef: MatDialogRef<ConfirmEmailSendDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      email_address: string;
      company_id: number;
      organization_id: number;
    },
  ) {
    this.email_address = data.email_address;
    this.company_id = data.company_id;
    this.organization_id = data.organization_id;

    /* La superficie del dialog e' un ANTENATO di questo componente (vive
       nell'overlay CDK), quindi il suo contorno e la fascia panna delle azioni
       non sono raggiungibili da uno stile incapsulato: servono le regole
       globali di .izy-info-dialog-panel, la veste neutra dei dialog che
       informano senza distruggere niente. .izy-auto-height-dialog-panel toglie
       in piu' l'altezza fissa che i chiamanti passano alla MatDialogConfig.
       Le classi le aggiunge il componente e non il chiamante perche' i punti
       di apertura sono cinque (lista fatture, dettaglio fattura, nuova
       fattura, fattura veloce, preventivi) e la veste e' la stessa per tutti:
       cosi' resta scritta in un punto solo, senza rischio di divergere. */
    this.dialogRef.addPanelClass([
      'izy-info-dialog-panel',
      'izy-auto-height-dialog-panel',
    ]);
  }

  openCustomerPage() {
    // const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.dialogRef.close(false);

    this.router.navigate([`/${this.organization_id}/company`, this.company_id]);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
